import { useState, useEffect } from 'react'
import { Box, CircularProgress } from '@mui/material'
import AccessCardFormat from './AccessCardFormat'
import {
  QUERY_ACCESS_CARD_FORMAT,
  IQueryAccessCardFormatData,
  IAccessCardFormat,
} from '../../graphql/users/queryAccessCardFormat'
import { useLazyQuery } from '@apollo/client'
import { colors } from '../../const/colors'
import { AccessCardType } from '../../graphql/users/queryUsersList'

interface IAccessCardTypeFormProps {
  setChosenFormat: (v: IAccessCardFormat) => void
  type?: AccessCardType
  currentFormat?: string
}

const AccessCardTypeForm = ({
  setChosenFormat,
  type,
  currentFormat,
}: IAccessCardTypeFormProps) => {
  const [cardFormats, setCardFormats] = useState<IAccessCardFormat[]>([])

  const onGetCardFormatsCompleted = (data: IQueryAccessCardFormatData) => {
    if (data.queryAccessCardFormat.length) {
      setCardFormats(
        data.queryAccessCardFormat.filter(f => !type || f.type === type),
      )
    }
  }

  const [getCardFormats, { loading }] =
    useLazyQuery<IQueryAccessCardFormatData>(QUERY_ACCESS_CARD_FORMAT, {
      onCompleted: onGetCardFormatsCompleted,
      fetchPolicy: 'no-cache',
    })

  useEffect(() => {
    getCardFormats()
  }, [])

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          minHeight: 200,
        }}
      >
        <CircularProgress size={40} sx={{ color: colors.navy }} />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '12px',
      }}
    >
      {cardFormats.map(item => (
        <AccessCardFormat
          key={item.name}
          label={item.name}
          number={item.exampleValue}
          onPress={() => setChosenFormat(item)}
          highlighted={item.name === currentFormat}
        />
      ))}
    </Box>
  )
}

export default AccessCardTypeForm
